import { Component, ElementRef, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cx-accordion',
  imports: [CommonModule, TranslateModule],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
})
export class AccordionComponent {
  @Input() title: string = '';
  @Input() icon: string = '';
  @Input() innerIcon: string = '';
  @Input() style: string = 'default';
  @Input() iconStyle: string = 'symbol';
  @Input() isActive?: boolean = false;
  @Input() id?: string = '';
  @Input() onClick?: (_event: MouseEvent, _id: string) => void;

  private hostElement = inject(ElementRef);

  get hostClasses(): string[] {
    const classList = Array.from((this.hostElement.nativeElement as HTMLElement).classList);

    classList.push(this.style);

    return classList;
  }

  toggleAccordion($event: MouseEvent, id?: string) {
    this.isActive = !this.isActive;

    if (this.onClick) {
      this.onClick($event, id || '');
      return;
    }
    return;
  }
}
